import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChildPropertyPipe } from './child-propery-pipe/child-propery.pipe';
import { FilterParamsPipe } from './filter-params/filter-params.pipe';
import { ItemResourceMetaPipe } from './item-resource-meta/item-resource-meta.pipe';
import { PageParamsPipe } from './page-params/page-params.pipe';
import { PluralizePipe } from './pluralize/pluralize.pipe';
import { PropertiesProfilesPipe } from './properties-profiles/properties-profiles.pipe';
import { PropertyResourceMetaPipe } from './property-resource-meta/property-resource-meta.pipe';
import { SortParamsPipe } from './sort-params/sort-params.pipe';
import { TrackPropertyByPipe } from './track-property-by/track-property-by.pipe';
import { CamelCaseSplitPipePipe } from './camel-case-split/camel-case-split-pipe.pipe';
import { CastPipe } from './cast/cast.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    FilterParamsPipe,
    ItemResourceMetaPipe,
    PageParamsPipe,
    PluralizePipe,
    PropertiesProfilesPipe,
    PropertyResourceMetaPipe,
    SortParamsPipe,
    TrackPropertyByPipe,
    ChildPropertyPipe,
    CamelCaseSplitPipePipe,
    CastPipe,
  ],
  exports: [
    FilterParamsPipe,
    ItemResourceMetaPipe,
    PageParamsPipe,
    PluralizePipe,
    PropertiesProfilesPipe,
    PropertyResourceMetaPipe,
    SortParamsPipe,
    TrackPropertyByPipe,
    ChildPropertyPipe,
    CamelCaseSplitPipePipe,
    CastPipe,
  ],
})
export class NgxHalPipesModule {}
